import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const ModifiersContext = createContext()

const ModifierProvider = ({ children }) => {

    const { headers, toast, restaurantId } = useAuth();

    const getAllModifiers = async (filter) => {
        const { totalRenderedRecords, limit, filter: filterModifier, restaurant_id } = filter

        try {
            let { data } = await axios.get(`${baseURL}/modifiers/list?limit=${limit ? limit : null}&totalRenderedRecords=${totalRenderedRecords >= 0 ? totalRenderedRecords : null}&restaurant_id=${restaurantId ? restaurantId : null}&filter=${filterModifier !== '' ? filterModifier : null}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Modifier', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const getAllModifierGroups = async (filter) => {
        const { totalRenderedRecords, limit, filter: modifierFilter } = filter

        try {
            let { data } = await axios.get(`${baseURL}/modifiers/group-list?limit=${limit ? limit : null}&totalRenderedRecords=${totalRenderedRecords >= 0 ? totalRenderedRecords : null}&restaurant_id=${restaurantId ? restaurantId : null}&filter=${modifierFilter !== '' ? modifierFilter : null}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Modifier Group', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    //Get All Modifier
    const fetchAllModifiers = async (currentPage, rowsPerPage, filter) => {
        try {
            let { data } = await axios.get(`${baseURL}/modifiers/fetch-all?page=${currentPage}&limit=${rowsPerPage}&filter=${filter !== '' ? filter : null}&restaurant_id=${restaurantId ? restaurantId : null}`, { headers })
            if (data.error === false) {
                return data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Modifier', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    //Get Single Modifier
    const getSingleModifier = async (id) => {
        try {
            let { data } = await axios.get(`${baseURL}/modifiers/single-modifier/${id}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Modifier', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    //add Modifier
    const createModifier = async (modifierDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/modifiers/create`, modifierDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Modifier', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Modifier', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Modifier', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Modifier', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Modifier', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    //add Modifier Group
    const createModifierGroup = async (modifierDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/modifiers/group/create`, modifierDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Modifier Group', detail: 'Modifier group created successfully.', life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Modifier Group', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    toast.current?.show({ severity: 'error', summary: 'Modifier Group', detail: errors[0].msg, life: 3000 })
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Modifier Group', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    //fetch modifiers by category
    const getModifierByCategory = async (id) => {
        try {
            let { data } = await axios.get(`${baseURL}/modifiers/modifiers-by-category/${id}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Modifier', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    //update Modifier
    const updateModifier = async (id, modifierDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/modifiers/update/${id}`, modifierDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Modifier', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Modifier', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Modifier', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Modifier', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Modifier', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    //update Modifier Group
    const updateModifierGroup = async (id, modifierDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/modifiers/group/update/${id}`, modifierDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Modifier Group', detail: 'Modifier group updated successfully.', life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Modifier Group', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    toast.current?.show({ severity: 'error', summary: 'Modifier Group', detail: errors[0].msg, life: 3000 })
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Modifier Group', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    //delete Modifier
    const deleteModifier = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/modifiers/delete/${id}`, { headers });
            return data
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Modifier', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    return (
        <ModifiersContext.Provider value={{ getAllModifiers, getAllModifierGroups, fetchAllModifiers, getSingleModifier, getModifierByCategory, createModifier, updateModifier, updateModifierGroup, createModifierGroup, deleteModifier }}>
            {children}
        </ModifiersContext.Provider>
    )
}

const useModifier = () => useContext(ModifiersContext)

export { useModifier, ModifierProvider }